import * as React from 'react';
import MapPostEventWrapper, { MapPostEventWrapperRef } from '../MapPostEventWrapper';
import { MapEvent } from '~config/map';

export type CreatedPlane = { id: number; uuid: string };

export interface GeoPlaneCreateProps {
  siteId: number | string;
  showZoom?: boolean;
  safeAreaTop?: number;
  height?: number | string;
  onPlaneCreated?: (plane: CreatedPlane) => void;
}

const GeoPlaneCreate: React.FC<GeoPlaneCreateProps> = ({ siteId, showZoom, safeAreaTop, height, onPlaneCreated }) => {
  const mapRef = React.useRef<MapPostEventWrapperRef>(null);

  React.useEffect(() => {
    if (!onPlaneCreated) return;
    // The geo-plane-create route emits PlaneSelected once the plane is created and its tiles
    // finish generating; its payload is the created plane object. Register directly (not via
    // onMapLoaded) because this route does not emit MapInitialised.
    const handler = (plane: CreatedPlane) => onPlaneCreated(plane);
    mapRef.current?.listenToEvent(MapEvent.PlaneSelected, handler);
    return () => mapRef.current?.removeEventListener(handler);
  }, [onPlaneCreated]);

  return (
    <MapPostEventWrapper
      ref={mapRef}
      page="geo-plane-create"
      siteId={siteId}
      showZoom={showZoom}
      safeAreaTop={safeAreaTop}
      height={height}
    />
  );
};

GeoPlaneCreate.displayName = 'GeoPlaneCreate';

export default GeoPlaneCreate;
